import { takeLatest, put, call, select } from 'redux-saga/effects'
import { Awaited } from 'global_types';
import { actions } from 'store/GuideUse/actions'
import { commentsStore } from 'store/GuideUse/CommentsStore'
import { AnyAction } from 'redux'
import { getGuideGeo, GetGuideEndpoint, GetGuideGeoResponse } from 'atlasguides-web-common/src/functions/guides/get-guide-geo';
import { getComments, GetCommentsEndpoint } from 'atlasguides-web-common/src/functions/comments/get-comments'
import { Comment } from 'atlasguides-web-common/src/functions/comments/dto/comment.dto';
import { GetGuideWaypointsEndpoint, GetGuideWaypointsResponse, getGuideWaypoints } from 'atlasguides-web-common/src/functions/guides/get-guide-waypoints';
import { userActions } from 'store/UserStore';
import { getPlannedRoutes, GetPlannedRoutesResponse } from 'atlasguides-web-common/src/functions/users/get-planned-routes';
import { AuthManagerService } from 'services/AuthManager/AuthManager';
import { GuideGeoExt } from 'commonTypes/GuideUse/guideGeo';
import { RouteTree } from 'services/Navigation/RouteTree';
import { DijkstraPath } from 'services/Navigation/GeoRouteBuilder/DijkstraPath';


function* getGuideDataSaga({payload: guideId}: AnyAction): Generator<unknown, void, Awaited<ReturnType<GetGuideEndpoint & GetGuideWaypointsEndpoint>>> {
  try {
    // Load guide geo data
    const request = { guideId }
    const res = (yield call<GetGuideEndpoint>(getGuideGeo, request)) as unknown as GetGuideGeoResponse;

    // Load waypoints
    const waypointsRes = yield call<GetGuideWaypointsEndpoint>(getGuideWaypoints, request) as unknown as GetGuideWaypointsResponse

    // Init GuideData
    const guideData: GuideGeoExt = {...res, waypoints: (waypointsRes as unknown as GetGuideWaypointsResponse).waypoints}
    RouteTree.initFromGuideData(guideData); // Initialize the route tree with the guide data
    guideData.dijkstraPath = new DijkstraPath(guideData);

    // Load planned routes (before actions.getGuideGeoDataResponse())
    const isSignedIn: boolean = AuthManagerService.getInstance().getIsSignedIn();
    // const isSignedIn: boolean = (yield select((state: UserState) => userSlice.getInitialState().isSignedIn))  as unknown as boolean;
    if (isSignedIn){
      try {
          request.guideId = res.guideId;
          const resultPlannedRoutes:GetPlannedRoutesResponse = (yield call(getPlannedRoutes, request)) as unknown as GetPlannedRoutesResponse;

          if (resultPlannedRoutes.success && resultPlannedRoutes.routes) {
              yield put(userActions.getPlannedRoutesResponse(resultPlannedRoutes.routes));
          }
      }
      catch (error) {
          yield put(userActions.getUserProfileFail());
          console.error(
            `Failed to get planned routes because of the following error;\n${error}`
          );
      }
    }

    yield put(actions.getGuideGeoDataResponse(guideData))


  } catch (error) {
    // yield put(actions.getAllTrailsListResponseFail(error.message))
    // console.log('failed')
  }
}

function* getWaypointCommentsSaga({payload: waypointId}: AnyAction): Generator<unknown, void, Awaited<ReturnType<GetCommentsEndpoint>>> {
  try {
    // Review cache to remove not actual items
    commentsStore.review();

    // Get from Cache
    if (commentsStore.hasCommentsForWaypoint(waypointId)){
      //console.log(`getWaypointCommentsSaga: '${waypointId}' read from cache`)
      yield put(actions.getWaypointCommentsResponse(commentsStore.getComments(waypointId)))
    }
    else{
      const request = { waypointId }

      //console.log(`getWaypointCommentsSaga: '${waypointId}' loading...`)
      const res = yield call(getComments, request)

      // Sort
      if (res.comments && res.comments.length > 0){
        res.comments.sort((a: Comment, b: Comment) =>
          new Date(b.date).getTime() - new Date(a.date).getTime()
        );
      }

      //console.log(`getWaypointCommentsSaga: '${waypointId}' loaded and added to cache: ` + JSON.stringify(res))
      commentsStore.add(res);

      yield put(actions.getWaypointCommentsResponse(commentsStore.getComments(waypointId)))
    }
  } catch (error) {
    // yield put(actions.getAllTrailsListResponseFail(error.message))
    console.error(`getWaypointCommentsSaga: failed to get comments because of the following error:\n${error}`
    );    
  }
}

export default function* saga(): Generator {
  yield takeLatest('@/GET_GUIDE_DATA_REQUEST', getGuideDataSaga)
  yield takeLatest('@/GET_WAYPOINT_COMMENTS_REQUEST', getWaypointCommentsSaga)
}
